var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.videoId)?_c('div',{staticClass:"yt-player",attrs:{"id":_vm.resourceId ? ("yt-player-" + _vm.resourceId) : _vm.videoId,"data-plyr-provider":"youtube","data-plyr-embed-id":_vm.videoId}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }